import React from 'react';
import classes from './style.module.scss';
import Icon from '~/app/common/Icon';
import useTranslation from '~/app/hooks/useTranslation';
import {AddIssueProps} from './../index';
import { IssueDetails } from '~/types';
import { isIssueAwaitingSync } from '~/data/sync/issueQueue';
import { usePendingIssues } from '~/issues/usePendingIssues';

export interface HeaderProps {
    type: AddIssueProps['type']
    issueId?: IssueDetails['id']
    issueDetails?: IssueDetails
}

export type HeaderComponent = React.FC<HeaderProps>;

const Header: HeaderComponent = ({ type, issueId, issueDetails }) => {
    const {t} = useTranslation('issue');
    const {t: tOffline} = useTranslation('offline');
    const { pending, loaded } = usePendingIssues(issueId ? [{ id: issueId, guid: issueDetails?.guid }] : []);
    const awaitingSync = !!issueId && isIssueAwaitingSync(
        pending,
        loaded,
        issueId,
        issueDetails?.guid,
        issueDetails?.pendingSync,
    );
    return (
        <div className={classes['model-header']}>
            {!issueId && <Icon name={type === 'repair' ? 'build' : 'report_problem'} className={classes['icon']}/>}
            <div className={classes['header-content']}>
                <label className={classes['title']}>
                    {t(issueId ? 'updateIssue' : (type === 'repair' ? 'addRepair' : 'addIssue'))}
                </label>
                {awaitingSync && <label className={classes['subtitle']}>{tOffline('awaitingSynchronization')}</label>}
            </div>
        </div>
    );
};

export default Header
